<template>
  <button
    type="button"
    @click.prevent="favoriteAuction"
  >
    <template v-if="loadingFavorite">
      <i class="fa fa-spin fa-spinner text-lg text-gray-500" />
    </template>
    <template v-else-if="isFavorite">
      <i class="fa fa-heart text-lg text-yellow-400" />
    </template>
    <template v-else>
      <i class="fa fa-heart text-lg text-gray-500" />
    </template>
  </button>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    auction: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      isFavorite: this.auction.favorite,
      loadingFavorite: false,
    };
  },

  methods: {
    favoriteAuction() {
      if (this.loadingFavorite) {
        return;
      }

      this.loadingFavorite = true;

      axios.post(route('frontend.api.favorite.auction'), {id: this.auction.id})
        .then(({data}) => {
          this.isFavorite = data.favorite;
          this.$page.props.customer.number_of_favorites += data.favorite ? 1 : -1;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$eventHub.$emit('login');
          }
        })
        .finally(() => this.loadingFavorite = false);
    },
  },
};
</script>
